<template>
	<modal size="large" @close="$emit('close')">
		<template #header>
			<div>
				<span>Process Order</span>
			</div>
		</template>
		<template #body>
			<div v-if="type === 'bulky'">
				<div v-for="(value, key) in form" :key="key">
					<FormField
						v-show="key !== 'rows'"
						:form-key="key"
						:form="form"
						:part-key="key"
						:errorMessage.sync="errorMessage"
						@on-change="onChangeForm"
					/>
				</div>

				<div v-if="(form.shipping_cost && form.other_cost) || (form.paymentType && form.paymentType.value && form.paymentType.value.key)" class="my-4">
					<hr />
					<div class="mb-2">
						Total Product Price : {{ formatMoney(data.total_price) }}
					</div>
					<div class="mb-2">
						Shipping Cost : {{ formatMoney(form.shipping_cost) }}
					</div>
					<div class="mb-2">
						Other Cost : {{ formatMoney(form.other_cost) }}
					</div>
					<div class="font-weight-bold">
						Total Pembayaran : {{ calculateTotalCost }}
					</div>
				</div>

				<div v-if="form.paymentType.value.key" class="border p-3" style="border-radius: 8px;">
					<div v-if="form.paymentType.value.key !== 'private_order_dp'" class="row">
						<div class="col-12 col-sm-6">
							<div class="form-group">
								<label>Nominal Pembayaran</label>
								<input
									:value="calculate"
									type="text"
									class="form-control"
									placeholder="Nominal Pembayaran"
									disabled
									@input="onChangeForm"
								>
								<small v-if="errorMessage && errorMessage.total_payment" class="text-danger">
									{{ errorMessage.total_payment }}
								</small>
							</div>
						</div>
						<div class="col-12 col-sm-6">
							<div class="form-group">
								<label>Due Date</label>
								<input v-model="due_date" type="date" class="form-control" @input="onChangeDate($event, 'due_date')">
							</div>
						</div>
					</div>
					<!-- Down Payment -->
					<div v-else>
						<div class="d-flex justify-content-between" style="gap: 20px;">
							<div class="d-flex items-center" style="align-items: center;">
								<span>Down Payment</span>
							</div>
							<div class="form-group" style="width: 100%;">
								<label>Nominal Pembayaran</label>
								<input v-model="total_payment" type="text" class="form-control" placeholder="Nominal Pembayaran" @input="onChangeDownPayment">
							</div>
							<div class="col-12 col-sm-6">
								<div class="form-group">
									<label>Due Date</label>
									<input v-model="due_date" type="date" class="form-control">
								</div>
							</div>
						</div>
						<div class="d-flex justify-content-between" style="gap: 11px;">
							<div class="d-flex items-center" style="align-items: center;">
								<span>Pelunasan</span>
							</div>
							<div class="form-group" style="width: 100%;">
								<label>Nominal Pembayaran</label>
								<input v-model="total_payment_settlement" disabled type="text" class="form-control" placeholder="Nominal Pembayaran" @input="onChangeForm">
							</div>
							<div class="col-12 col-sm-6">
								<div class="form-group">
									<label>Due Date</label>
									<input v-model="due_date_settlement" type="date" class="form-control">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="type === 'outsource'">
				<span>
					Apakah anda yakin akan memproses orderan #{{ data.order_id }}
				</span>
			</div>
		</template>
		<template #footer>
			<div class="d-flex justify-content-end">
				<button class="btn btn-light" @click="$emit('close')">
					Cancel
				</button>
				<button
					class="btn btn-primary"
					:class="{ 'is-loading': isSubmitLoading }"
					:disabled="isBtnDisabled"
					@click="submit"
				>
					Simpan
				</button>
			</div>
		</template>
	</modal>
</template>

<script>
import dayjs from 'dayjs';
import Modal from '@/components/Modal.vue';
import FormField from '@/components/private-orders/modal/form.vue';
import { formatMoney } from '@/lib/helper';

export default {
	name: 'ModalProcessOrder',
	components: {
		Modal,
		FormField,
	},
	props: {
		type: {
			type: String,
			default: '',
		},
		data: {
			type: Object,
			default: () => { },
		},
		isSubmitLoading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			form: {
				shipping_cost: 0,
				other_cost: 0,
				paymentMethod: {
					value: '',
					options: [
						{
							label: 'Bank Transfer',
							key: 'bank_transfer',
							$isDisabled: false,
						},
						{
							label: 'Instant',
							key: 'instant',
							$isDisabled: false,
						},
					],
				},
				paymentType: {
					value: '',
					options: [
						{
							label: 'Full Payment',
							key: 'full_payment',
							$isDisabled: false,
						},
						// {
						// 	label: 'DP (Down Payment)',
						// 	key: 'private_order_dp',
						// },
						{
							label: 'Invoicing',
							key: 'invoicing',
							$isDisabled: false,
						},
					],
				},
				rows: {},
			},
			total_payment: 0,
			due_date: null,
			total_payment_settlement: 0,
			due_date_settlement: null,
			errorMessage: {
				total_payment: '',
				shipping_cost: '',
			},
		};
	},
	watch: {
		'form.paymentType.value.key': function (value) {
			const calculate = this.data.total_price + this.form?.shipping_cost + this.form?.other_cost;
			if (value !== 'private_order_dp') {
				this.total_payment = calculate;
			} else {
				this.total_payment = 0;

				if (this.due_date) {
					this.due_date_settlement = dayjs(this.due_date).add(3, 'day').format('YYYY-MM-DD');
				}
			}
		},
		calculate(value) {
			if (value) {
				this.total_payment = value;
			}
		},
	},
	computed: {
		isBtnDisabled() {
			return ((this.total_payment === 0 && !this.due_date) || Number(this.calculate) < 0 || this.isSubmitLoading || this.total_payment_settlement < 0 || (!this.form?.paymentType?.value && !this.form?.form?.paymentType?.value?.key) || this.errorMessage.total_payment !== '') && this.data.order_type === 'bulky';
		},
		calculate() {
			const totalPrice = Number(this.data.total_price) || 0;
			const shippingCost = Number(this.form?.shipping_cost) || 0;
			const otherCost = Number(this.form?.other_cost) || 0;

			return totalPrice + shippingCost + otherCost;
		},
		calculateTotalCost() {
			return formatMoney(this.calculate);
		},
	},
	created() {
		this.init();
	},
	methods: {
		formatMoney,
		init() {
			if (this.data) {
				this.due_date = dayjs().add(3, 'day').format('YYYY-MM-DD');
				this.form.paymentMethod.value = {
					label: this.data?.payment_info?.split('_')
						.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
						.join(' '),
					key: this.data?.payment_info,
				};
			}
		},
		onChangeForm(data, key) {
			if (data && key) {
				this.form = data;
			} else {
				const value = data?.target?.value;

				const cleanedInput = value.replace(/[^0-9.-]+/g, '');

				const numberValue = parseFloat(cleanedInput);

				if (!Number.isNaN(numberValue)) {
					this.total_payment = numberValue;
				} else {
					this.total_payment = '';
				}

				if (this.total_payment < this.calculate) {
					this.errorMessage.total_payment = 'Nominal pembayaran kurang dari total pembayaran';
				} else {
					this.errorMessage.total_payment = '';
				}
			}
		},
		onChangeDownPayment() {
			const cleanedInput = this.total_payment.replace(/[^0-9.-]+/g, '');

			const numberValue = parseFloat(cleanedInput);

			if (!Number.isNaN(numberValue)) {
				this.total_payment = numberValue;
			} else {
				this.total_payment = '';
			}
			const calculate = this.calculate;
			this.total_payment_settlement = (calculate - numberValue) ?? 0;
		},
		onChangeDate(event, field) {
			const date = dayjs(event.target.value);
			this[field] = date.format('YYYY-MM-DD');
		},
		submit() {
			const params = {
				shipping_cost: Number(this.form.shipping_cost),
				other_cost: Number(this.form.other_cost),
				type: this.form?.paymentType.value?.key,
				payment_method: this.form?.paymentMethod.value?.key,
			};

			if (this?.form.paymentType?.value?.key === 'private_order_dp') {
				params.dp = {
					total_payment: this.calculate,
					due_date: this.due_date,
					total_payment_settlement: this.total_payment_settlement,
					due_date_settlement: this.due_date_settlement,
				};
			} else {
				params.total_payment = Number(this.calculate);
				params.due_date = this.due_date;
			}

			this.$emit('submit', params);
		},
	},
};
</script>
